
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import IconRfid from '@/components/svg/IconRfid.vue'
import IconLinkDevice from '@/components/svg/IconLinkDevice.vue'
import RfidItemSelector from '@/views/bizBrowser/RfidItemSelector.vue'
import RfidDeviceSelector from '@/views/bizBrowser/RfidDeviceSelector.vue'
import { SendToBizBrowser } from '@/utils/bizBrowser/sendToBizBrowser'
import { RfidScanParsedResult } from '@/utils/bizBrowser/rfidScanResultHandler'

@Options({
  components: {
    IconRfid,
    IconLinkDevice,
    RfidItemSelector,
    RfidDeviceSelector,
  },
  emits: ['rfid:confirmed'],
})
export default class RfidScanButton extends Vue {
  @Prop({ type: String, default: 'multiple-select' }) readonly mode!: 'single-select' | 'multiple-select'
  @Prop({ type: Function, required: false }) readonly onConfirm?: (rfidList: RfidScanParsedResult[]) => void

  showRfidScanDialog = false
  showDeviceSelector = false

  get isConnectedWithRfidDevice() {
    return this.$store.getters.bizBrowserState.isConnectedWithRfidDevice
  }

  onClickLinkRfidDevice() {
    this.showDeviceSelector = true
  }

  onDeviceSelected() {
    SendToBizBrowser.connectWithScanner()
  }

  onClickRfidScan() {
    this.showRfidScanDialog = true
  }

  onRfidScanConfirm(rfidList: RfidScanParsedResult[]) {
    if (this.onConfirm) {
      this.onConfirm(rfidList)
    }
    this.$emit('rfid:confirmed', rfidList)
  }
}
